import React from 'react';
import { PayPalButton } from 'react-paypal-button-v2';
import { Spinner } from 'react-activity';
export default class PayPalBtn extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loaded: false
		};
	}

	componentDidMount() {}

	componentWillUnmount() {}

	render() {
		const { amount, onSuccess } = this.props;
		// props.onSuccess()
		if (!this.props.clientId) return <p>Pagamento PayPal non disponibile: configurazione mancante.</p>;
		return (
			<div>
				{!this.state.loaded && <Spinner />}
				<PayPalButton
					// id="asd"
					amount={amount}
					currency="EUR"
					createOrder={(data, actions) => actions.order.create({
						purchase_units: [{
							custom_id: `dm-credits-${this.props.orderID}`,
							amount: { currency_code: 'EUR', value: amount }
						}]
					})}
					// catchError={(err) => {
					//     this.props.history.push({
					//         pathname: '/paypal-error',
					//         query: {orderId: this.props.orderID, type: this.props.paymentType}
					//     });
					//
					//     console.log({err})
					// }}
					onButtonReady={() => this.setState({ loaded: true })}
					onError={err => {
						this.props.history.push({
							pathname: '/paypal-error',
							query: {
								orderId: this.props.orderID,
								type: this.props.paymentType
							}
						});
					}}
					onApprove={(data, actions) => actions.order.capture().then(details => onSuccess(details, data))}
					onClick={() => {
						setTimeout(() => {
							this.props.onClick();
						}, 500);
					}}
					onCancel={(err, data) => {
						this.props.history.push({
							pathname: '/paypal-error',
							query: {
								orderId: this.props.orderID,
								type: this.props.paymentType
							}
						});
					}}
					style={{
						layout: 'horizontal'
					}}
					// components={}
					options={{
						clientId: this.props.clientId,
						currency: 'EUR'
					}}
				/>
			</div>
		);
	}
}
